
export const database ={

    data(){
        return {
            management: [

                { 
                    id: '1',
                    title: '' , 
                    fullname: 'Olusola Olunowo', 
                    position: 'Managing Director', 
                    featured_thumbnail: '/img/1.png',
                    featured_image: '/img/1.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Sola Olunowo, is a graduate of the University of Ibadan, He has extensive experience in Business Development and Project Management. Sola has managed, trained and supported end user platforms for over 24 years. He has worked with many international organizations with best global practices managing large complex implementation programs.</p><p>He has a pragmatic, logical and analytical approach to all aspects of work and fosters a ‘can do’ team spirit, a “self-starter”, and “self-motivated” Project Manager, experienced in leading multi-disciplinary teams.</p>',
                        overview_image: '',
                    }
            
                },

                { 
                    id: '2',
                    title: 'Mr' , 
                    fullname: 'Seun Oloyede', 
                    position: 'Chief Financial Officer', 
                    featured_thumbnail: '/img/2.png',
                    featured_image: '/img/2.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Seun Oloyede is a seasoned and highly motivated accounting professional with over 10years working experience and has a strong background in corporate and business accounting. He possesses excellent knowledge in finance, accounting, operations, and management. He also gained diverse experience from different sector such as Technology, Retail, financial services, investment bank, accountancy and security, and engaged in various administrative roles.</p><p> He has participated in various equity and debt funding both in Nigeria and United Kingdom. He is certified by ACCA, Wales and hold a Bachelor degree in Applied Accounting from Oxford Brookes University, United Kingdom. He equally studied at the London School of Business and Finance. He is currently studying Master degree in Agribusiness and Management from Rome Business School. He was head of finance for Core Trust and Investment Ltd, Ruffn Tumble and Group CFO for Tivas Group before joining AgroPark Development company Limited.</p>',
                        overview_image: '',
                    }
            
                },

                { 
                    id: '3',
                    title: 'Mr' , 
                    fullname: 'Emmanuel A Alabi', 
                    position: 'Chief Operations Officer', 
                    featured_thumbnail: '/img/3.png',
                    featured_image: '/img/3.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Ayodele Alabi is a devoted lifetime learner with passion for leadership, organizational behavior and development. He is zealous about bringing the best out of people. Ayodele has over 10 year’s career experience in Banking Operations and Client Service Management. He is a certified member of the Chartered Institute of Customer Relationship Management.</p> <p>An alumnus of Yaba College of Technology, he also holds a Post Graduate Diploma in Public Relations and Masters in Business Administration. He has attended several leadership courses from the renowned Lagos Business School and other training institutes within and outside Nigeria.</p>',
                        overview_image: '',
                    }
            
                },

                { 
                    id: '4',
                    title: 'Mr' , 
                    fullname: 'Babatunde Oyelade', 
                    position: 'International Desk', 
                    featured_thumbnail: '/img/4.png',
                    featured_image: '/img/4.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Babatunde Oyelade is a graduate of the University of Lagos. He started his career as a retail banking officer with Pacific Bank (Now Unity Bank) in 2004. He gained employment with Liberty Life, South Africa, as a Financial Consultant; he later rose to become sales manager in the same company, a position he held up until his return to Nigeria. In 2009, he was poached by another South African company called Metropolitan Life as part of a joint venture in Nigeria with United Bank for Africa (UBA) where he became the pioneer business coordinator of UBA Metropolitan Life in the Ibadan and entire south west region.</p><p>In 2011, he left UBA Metropolitan Life for UNIC Insurance Plc, one of the foremost insurance companies in Nigeria as the Head of Retail business for Ibadan and environs. Tunde as he’s fondly called is an astute and seasoned business manager with rich and diverse leadership experience in business development, operations management, channel team management, business strategy development, customer relationship management, organizational management, conflict resolution, spanning over 15 years.</p>',                      overview_image: '',
                    }
            
                },

                { 
                    id: '5',
                    title: 'Mrs' , 
                    fullname: 'Adenike Fagun', 
                    position: 'General Manager', 
                    featured_thumbnail: '/img/5.png',
                    featured_image: '/img/5.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Adenike Fagun studied Industrial Relations and Personnel Management from Lagos State University and an Associate member of Chartered Institute of Personnel Management (CIPM).</p><p>Nike has over 10 years managerial experience and possess excellent management skills with extensive knowledge of key issues like Customer Service management, Administration, Inventory management and effective labour scheduling. She has the charism to lead, coach, develop and motivate teams.</p>',
                        overview_image: '',
                    }
            
                },

                { 
                    id: '6',
                    title: 'Mr' , 
                    fullname: 'Adetoro Olayomi', 
                    position: 'Head, Marketing Comunications', 
                    featured_thumbnail: '/img/6.png',
                    featured_image: '/img/6.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Adetoro Olayomi is an energetic team player with exceptional managerial and execution skills. An astute administrator, he has ability to multitask, manage and coordinate diverse groups. With over 13 years’ experience in business support and administration, he has developed prowess for efficient planning and quality service delivery.</p><p>Adetoro holds a B.Sc (Ed) in Accounting Education from University of Ado-Ekiti and PGD in Public Relations and Advertising from Nigerian Institute of Journalism. He is a certified member of the Project Management Professional Institute (PMPI).</p>',
                        overview_image: '',
                    }
            
                },

                { 
                    id: '7',
                    title: 'Mr' , 
                    fullname: 'Deji Afolami', 
                    position: 'Head, Poultry And Livestock', 
                    featured_thumbnail: '/img/7.png',
                    featured_image: '/img/7.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Deji Afolami is a young, energetic and calm Agripreneur with over 7 years experience in both Crop and Livestock production. A Crop Production graduate from Olabisi Onabanjo University, he obtained a Masters degree in Agronomy from the University of Ibadan and currently running a PhD program at the Federal University of Agriculture, Abeokuta.</p><p>He is an Alumnus of the Daystar Leadership Academy; he has undertaken several trainings on leadership, management and Agriculture within and outside Nigeria. Deji has successfully managed over 500 hectares of integrated farm with full compliance to Global Good Agricultural Practices standards.</p>',
                        overview_image: '',
                    }
            
                },
                { 
                    id: '8',
                    title: 'Mr' , 
                    fullname: 'Adetominiyi A Adebisi', 
                    position: 'Head, Crop Production', 
                    featured_thumbnail: '/img/8.png',
                    featured_image: '/img/8.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Afeez Adebisi has MSC. In Agronomy from the University of Ibadan. He is a certified professional in Good Agricultural Practices, Hazard Analysis and Critical Control Point.</p><p>Afeez has appraised and managed diverse farms for 8 years and has great experience in consultancy services with focus on Farm setting and layouts, Farm Management Crop nutrition.</p>',
                        overview_image: '',
                    }
            
                },


            ], 

        advisory: [

                { 
                    id: '9',
                    title: '' , 
                    fullname: 'Jubril Gbajabiamila', 
                    // position: 'Managing Director', 
                    featured_thumbnail: '/img/ano.png',
                    featured_image: '/img/ano.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Jubril Gbajabiamila is a graduate of Brown University. He is a company executive and an experienced chairman of the board with a demonstrated history of working in the management consulting industry. </p> <p>He is a strong entrepreneurship professional who has been able to master over the years Negotiation, business planning, energy, risk management and corporate finance. </p>',
                        overview_image: '',
                    }
            
                },

                { 
                    id: '10',
                    title: ' ' , 
                    fullname: 'Boye Oloyede', 
                    // position: 'Chief Financial Officer', 
                    featured_thumbnail: '/img/ano.png',
                    featured_image: '/img/ano.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Boye Oloyede is an innovative strategic life coach with a passion for leadership and excellence. He has over 17 year’s career experience in areas of Project management, I.T, People Development and Consultancy. </p> <p>He is a certified I.T specialist, holding certification in project management institute, U.S.A as a project management professional. Boye is one of the brains in the renowned Daystar Leadership Academy, Africa’s premier leadership development school and also, an associate pastor with Daystar Christian Center, Lagos. </p>',
                        overview_image: '',
                    }
            
                },

                { 
                    id: '11',
                    title: ' ' , 
                    fullname: 'Adejoke Oyeronke', 
                    // position: 'Chief Operations Officer', 
                    featured_thumbnail: '/img/ano.png',
                    featured_image: '/img/ano.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Adejoke Oyeronke Araoye is an Associate member of the Institute of personnel Management of Nigeria with 18 years’ experience in Human resources and Administration in different organizations. She obtained her first degree in Finance and Master’s degree in Business Administration.</p> <p> She has a multi-country experience in HR and Administration having worked within the West Coast of Africa, Morocco, middle and Southern Africa. She currently worked with a Swedish Multinational Company in Lagos. </p>',
                        overview_image: '',
                    }
            
                },

                { 
                    id: '12',
                    title: ' ' , 
                    fullname: 'Professor Lateef Sanni', 
                    // position: 'International Desk', 
                    featured_thumbnail: '/img/ano.png',
                    featured_image: '/img/ano.png', //dimension 480px x 515px
                    info: {
                        phone: '',
                        email: '',
                        address: '',
                        facebook: '',
                        twitter: '',
                        instagram: '',
                        overview: ' <p>Professor Sanni Lateef Oladimeji is a researcher and a leader. He joined FUNAAB in 1993 as Assistant Lecturer and became Professor (Food Science and Technology) in 2008. Prof. Sanni has over 20 years experience in research, consultancy and collaborations as a postharvest expert on Tropical Root Crops mostly in West Africa coupled with missions to Latin America, Asia, Europe and other parts of Africa mostly implemented by the International Institute of Tropical Root Crop and Natural Resources Institute, UK, respectively</p> <p>He is the Immediate Past National President, Nigerian Institute of Food Science and Technology. Being passionate about Agriculture, he contributed to the emergence of World Bank Centre of Excellence in Agriculture and sustainable environment in 2013 for the Federal University of Agriculture.</p> <p>He is the Country Manager for Nigeria in a five-Country project. Presently, he is the president of National Society for Tropical Root Crops (ISTRC) and a former Vice Chancellor of Federal University of Agriculture Abeokuta. </p>',                      
                        overview_image: '',
                    }
            
                },


            ], 
   
            


        }
    },


    methods:{

       
        fetchProfileUsingName(fullname){

            //filter array of object based
            let x = this;
            var result = x.management.filter(function(data, index) {
                return data.fullname.toLowerCase() == fullname;
            });

           return result;

        },
        fetchProfileUsingAdvisoryName(fullname){

            //filter array of object based
            let x = this;
            var result = x.advisory.filter(function(data, index) {
                return data.fullname.toLowerCase() == fullname;
            });

           return result;

        },

    }

    

}